import React, { useContext } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import { useInput } from "../../../../../hooks/useInput";
import { Checkbox } from "../../../../../components/Checkbox";
import { useOnChange } from "../../../../../hooks/useOnChange";
import { InputText } from "../../../../../components/InputText";
import { EntryContext } from "../../../../../contexts/EntryContext";
import { InputNumber } from "../../../../../components/InputNumber";
import { useValidation } from "../../../../../hooks/useValidation";

const PlanItemStyle = styled.div`
    >div:nth-child(1) {
        margin-bottom: 10px;
    }
    >div:nth-child(2) {
        gap: 8px;
        display: grid;
        align-items: flex-end;
        grid-template-columns: 25px 60px 1fr 1fr
    }
`;

export const MainItem = props => {
    const { ixusArea } = props;

    const entryContext = useContext(EntryContext);
    const { entry } = entryContext;

    const inputName = "ixus-area-" + ixusArea.planKey;
    const plan = entry.plans.find(e => e.key === ixusArea.planKey);

    const name = useInput(inputName + "-name", plan.layerName);
    const sideView = useInput(inputName + "-sideView", ixusArea.sideView);
    const angle = useInput(inputName + "-angle", ixusArea.angle);
    const heightTop = useInput(inputName + "-heightTop", ixusArea.heightTop);
    const heightBottom = useInput(inputName + "-heightBottom", ixusArea.heightBottom);

    useValidation(() => {
        if (ixusArea.sideView) {
            return angle.value !== null;
        }
        return true;
    }, [angle]);

    useValidation(() => {
        if (ixusArea.sideView) {
            return true;
        }
        return heightTop.value !== null;
    }, [heightTop]);

    useValidation(() => {
        if (ixusArea.sideView) {
            return true;
        }
        return heightBottom.value !== null;
    }, [heightBottom]);

    useOnChange((name, value) => {
        if (value === true) {
            angle.set(ixusArea.angle || 0);
            heightTop.set(null);
            heightBottom.set(null);
        } else if (value === false) {
            angle.set(null);
            heightTop.set(ixusArea.heightTop || 0);
            heightBottom.set(ixusArea.heightBottom || 0);
        }
        entryContext.setEntry(entry);
    }, [sideView]);

    useOnChange((name, value) => {
        const cleanName = name.replace(inputName + "-", "");
        ixusArea[cleanName] = value;
        entryContext.setEntry(entry);
    }, [sideView, angle, heightTop, heightBottom]);

    return (
        <PlanItemStyle>
            <div>
                <InputText {...name.bind}
                    disabled={true}
                    maxLength="40"
                    title={intl.get("entry.ixus.main.name")} />
            </div>
            <div>
                <Checkbox {...sideView.bind}
                    title={intl.get("entry.ixus.main.sideView")} />
                <InputNumber {...angle.bind}
                    type="number"
                    disabled={!sideView.value}
                    fractionDigits={2}
                    title={intl.get("entry.ixus.main.angle")} />
                <InputNumber {...heightBottom.bind}
                    type="number"
                    disabled={sideView.value}
                    fractionDigits={2}
                    title={intl.get("entry.ixus.main.heightBottom")} />
                <InputNumber {...heightTop.bind}
                    type="number"
                    disabled={sideView.value}
                    fractionDigits={2}
                    title={intl.get("entry.ixus.main.heightTop")} />
            </div>
        </PlanItemStyle>
    );
};